import type { FaireProductEntity } from "../../entity_types/product";

export const p_cy5ja2t7h3: FaireProductEntity = {
  token: "p_cy5ja2t7h3",
  type: "product",
  name: "Girls Summer Bow Embroidered Outdoor Solid Baseball Cap",
  brandToken: "b_9krr246qu7",
  brandName: "Auraquise",
  imageUrl:
    "https://cdn.faire.com/fastly/499b3e1a79bd3267c81e9f31980e7c19cb12c2f1a897e4fd223509f8f8ede08a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/80b2694563ebf7ee048d2c2e3f186138f699c408d795391899164ddeba61a4fc.jpeg",
    "https://cdn.faire.com/fastly/a970995963b564e706f87e79080cac26d0212106dd79d9bc6d869448f568503e.jpeg",
    "https://cdn.faire.com/fastly/51b1c34f5fef529e9a359b897afaa16966d495dc544e2a316a1dee781ec8e3c4.jpeg",
    "https://cdn.faire.com/fastly/70ca39feabf2e4e7814650307e72493166c6b057d2be4a00e122447b87182c7c.jpeg",
    "https://cdn.faire.com/fastly/df17e057584375c5d72a526529c2b7393b5c1a158f94a85341d3ca3a80d73aad.jpeg",
    "https://cdn.faire.com/fastly/41c98b485786a6b6768dd9e7e43e39c7669f9495ee239407afdcf6a08a9b640d.jpeg",
    "https://cdn.faire.com/fastly/53b0ef34160624db7a115f79d75b19a3fa730293fa15c180f2c7f7df6fd1f1aa.jpeg",
  ],
  priceDollars: 5.59,
  description:
    "\nStay cool and stylish this summer with our Girls Summer Bow Embroidered Outdoor Solid Baseball Cap. The perfect accessory for any outdoor adventure, with its embroidered design and comfortable fit. Keep the sun out of your eyes and show off your playful style. \n",
  tags: [],
  msrpDollars: 11.18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:50:39.305Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
